import { Box, Grid, Typography } from "@mui/material";
import styles from "../InternalTracker.module.css";
import { customTextColor } from "../../../utils/const";
import { useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import Checkbox from '@mui/material/Checkbox';
const InternalTrackerAddReview = () => {
  const [showMore, setShowMore] = useState(false);
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  return (
      <Box className={styles.candidate_structure}>
        <Box className={styles.review_header} sx={{ color: customElements }}>
          <Typography>Profile Complete 75%</Typography>
          <Typography>Resume</Typography>
        </Box>
        <Grid
          container
          className={styles.profile_details_view}
          sx={{ color: customTextColor, margiTop: "10px" }}
        >
          <Grid
            item
            md={6}
            lg={6}
            sx={{ display: "block !important" }}
            className={styles.profile_details_views}
          >
            <ul style={{ listStyleType: "square", padding: "20px" }}>
              <Box>
                <li>
                  <Typography>
                    User ID: <b>DD01243</b>
                  </Typography>
                </li>
              </Box>
              <Box>
                <li>
                  <Typography>
                    Job Profile:<b>Senior Java Developer</b>
                  </Typography>
                </li>
              </Box>

              <Box>
                <li>
                  <Typography>
                    Location: <b>Dallas Taxes, TX </b>
                  </Typography>
                </li>
              </Box>

              {showMore && (
                <>
                  <Box>
                    <li>
                      <Typography>
                        Work Preference:<b> Remote </b>
                      </Typography>
                    </li>
                  </Box>

                  <Box>
                    <li>
                      <Typography>
                        Contact No: <b> 9437-214-771 </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Time Zone: <b> PST </b>
                      </Typography>
                    </li>
                  </Box>

                  <Box>
                    <li>
                      <Typography>
                        Domain: <b> Healthcare </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box sx={{ marginBottom: "0 !important" }}>
                    <li>
                      <Typography>
                        University: <b>Boston Texas in 2015 </b>
                      </Typography>
                    </li>
                  </Box>
                </>
              )}
            </ul>
          </Grid>

          <Grid
            item
            md={6}
            lg={6}
            sx={{ display: "block !important" }}
            className={styles.profile_details_views}
          >
            <ul style={{ listStyleType: "square" }}>
              <Box>
                <li>
                  <Typography>
                    Name: <b>Mounika Gulkuri</b>
                  </Typography>
                </li>
              </Box>
              <Box>
                <li>
                  <Typography>
                    Experience: <b> 12 Years </b>
                  </Typography>
                </li>
              </Box>

              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <li>
                  <Typography>
                    Prefer Location: <b> Chennai, Delhi </b>
                  </Typography>
                </li>
                {showMore === false && (
                  <IoIosArrowDown
                    style={{ color: customTextColor, cursor: "pointer" }}
                    onClick={() => setShowMore(!showMore)}
                  />
                )}
              </Box>

              {showMore && (
                <>
                  <Box>
                    <li>
                      <Typography>
                        Salary: <b>Not Disclosed </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        E-Mail ID:<b>pratikreaddy@gmail.com </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Current Location: <b>Ratmithali, Kolkata, KK </b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Organization: <b>ABC Technologies Pvt Ltd</b>
                      </Typography>
                    </li>
                  </Box>
                  <Box>
                    <li>
                      <Typography>
                        Qualifications:<b> B Tech </b>
                      </Typography>
                    </li>
                  </Box>

                  <Box
                    sx={{
                      marginBottom: "0 !important",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <li>
                      <Typography>
                        Linked in Profile: <b>pratick_java.linkedin.com </b>
                      </Typography>
                    </li>
                    {showMore && (
                      <IoIosArrowUp
                        style={{ color: customTextColor, cursor: "pointer" }}
                        onClick={() => setShowMore(!showMore)}
                      />
                    )}
                  </Box>
                </>
              )}
            </ul>
          </Grid>
        </Grid>
        <Box className={styles.candidate_listing_text}>
    <Box style={{ color: customTextColor }}>
        <Typography>
            <b>Who can view your tracker profile?</b>
        </Typography>
        
        <Typography>
            <Checkbox {...label} /> Only Me
        </Typography>
        
        <Typography>
            <Checkbox {...label} /> Me and My Colleagues
        </Typography>
    </Box>
    <button style={{ alignSelf: "flex-end" }}>Confirm</button>
</Box>

      </Box>
  );
};

export default InternalTrackerAddReview;
